import { Sensors } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useWeatherStation } from './api/getWeatherStation';

interface Props {
  stationId?: number;
  sx?: any;
}

const WeatherStationsIcon = ({ stationId, sx }: Props) => {
  const { data: station } = useWeatherStation({ stationId });
  return (
    <Tooltip
      title={station?.name ? station.name : 'Weather Station Active'}
      placement='top-start'
    >
      <Sensors sx={sx} />
    </Tooltip>
  );
};

export default WeatherStationsIcon;
